import React, { createContext, useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setInitialAuthState,
  selectUser,
  selectIsAuthenticated,
} from "../features/auth/authSlice";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const isAuthenticated = useSelector(selectIsAuthenticated);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      dispatch(setInitialAuthState(JSON.parse(storedUser)));
    }
  }, [dispatch]);

  const value = { user, isAuthenticated };
  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export default function useAuth() {
  return useContext(UserContext);
}
